import { sidebarNavConfig } from "@/config/nav";

interface Menu {
  [key: string]: any;
}

export const buildMenuFromPermissions = (
  permissions: string[],
  oidcRoles: string[],
): { items: Menu } => {
  const menu: Menu = {};

  if (permissions.includes("admin_service_partner_read")) {
    menu["servicepartners"] = sidebarNavConfig.items["servicepartners"];
  }
  if (permissions.includes("admin_company_read")) {
    menu["companies"] = sidebarNavConfig.items["companies"];
  }
  if (oidcRoles.includes("ROLE_OIDC_ADMIN")) {
    menu["affiliates"] = sidebarNavConfig.items["affiliates"];
  }
  if (permissions.includes("admin_dossier_read")) {
    menu["dossiers"] = sidebarNavConfig.items["dossiers"];
  }
  if (permissions.includes("admin_dealer_direct_generic_dossier_create")) {
    menu["dealer-intake"] = sidebarNavConfig.items["dealer-intake"];
  }
  if (permissions.includes("admin_email_template_read")) {
    menu["email-templates"] = sidebarNavConfig.items["email-templates"];
  }
  if (permissions.includes("admin_sms_template_read")) {
    menu["sms-templates"] = sidebarNavConfig.items["sms-templates"];
  }
  if (permissions.includes("admin_rule_read")) {
    menu["rules"] = sidebarNavConfig.items["rules"];
  }
  if (permissions.includes("admin_rule_action_read")) {
    menu["actions"] = sidebarNavConfig.items["actions"];
  }
  if (permissions.includes("admin_external_webhook_read")) {
    menu["external-webhooks"] = sidebarNavConfig.items["external-webhooks"];
  }
  if (permissions.includes("admin_image_capture_read")) {
    menu["image-captures"] = sidebarNavConfig.items["image-captures"];
  }
  if (permissions.includes("admin_image_capture_account_read")) {
    menu["image-captures-accounts"] =
      sidebarNavConfig.items["image-captures-accounts"];
  }
  if (permissions.includes("admin_user_read")) {
    menu["users"] = sidebarNavConfig.items["users"];
  }
  if (permissions.includes("admin_user_role_read_details")) {
    menu["roles"] = sidebarNavConfig.items["roles"];
  }
  if (permissions.includes("admin_user_permission_read")) {
    menu["permissions"] = sidebarNavConfig.items["permissions"];
  }
  if (permissions.includes("admin_data_analytics_ownership_read")) {
    menu["analytics"] = sidebarNavConfig.items["permissions"];
  }

  return {
    items: menu,
  };
};
